import { z } from "zod";

export const FlightState = z.union([
	z.literal("airborne"),
	z.literal("ground"),
]).nullable();

export const FlightStatePublishSchema = z.object({
	aircraftId: z.string(),
	flightState: FlightState,
	flightStateUpdatedAt: z.date(),
});

export type FlightStatePublish = z.infer<typeof FlightStatePublishSchema>;